import { render } from "./LoginDialog.vue?vue&type=template&id=5ff689d4&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&lang=js"
export * from "./LoginDialog.vue?vue&type=script&lang=js"

import "./LoginDialog.vue?vue&type=style&index=0&id=5ff689d4&scoped=true&lang=css"

import exportComponent from "F:\\SUPERChat\\SuperBot-ChatGPTApp\\SUPER_WEB\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@17.1.1_@vue+compiler-sfc@3.3.4_vue@3.2.13_webpack@5.84.1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff689d4"]])

export default __exports__